/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiResponseModel } from "src/types/common"
import axiosInstance from "./axios"
import {
  AuthenIdModel,
  AuthenIdRequestModel,
  CustomerDetailModel,
  CustomerDetailRequestModel,
  ValidateRequestOtpModel,
} from "src/types/customer"

const customerApis = {
  get: (payload: CustomerDetailRequestModel) =>
    axiosInstance.post<any, ApiResponseModel<Array<CustomerDetailModel>>>(
      "/customerdetail",
      payload
    ),
  getAuthenId: (payload: AuthenIdRequestModel) =>
    axiosInstance.post<any, ApiResponseModel<AuthenIdModel>>(
      "/getOtp",
      payload
    ),

  validatOpt: (payload: ValidateRequestOtpModel) =>
    axiosInstance.post<any, ApiResponseModel<any>>("/validateotp", payload),
}

export default customerApis
